export enum EnumModeloECF {
    CFE_MAQUINA_REGISTRADORA = "2B",
    CFPDV = "2C",
    CF_ECF = "2D"
}